module.exports = __webpack_public_path__ + "img/leafTx-hint.c91723d2.png";